exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3BD4fCxoBlGb_o_dYiDsnI{padding:1.42857rem 0}._1eK_pN6JRHDFwhQ5BUsBjK{padding:0 2.14286rem}.AKbfVU8T4wHf_h3cSbtiI{margin-bottom:.71429rem}._3-hjxuS4QEEKDziXYpc0Kx{list-style:none;padding-left:0}._1_TS11IOA9_RwLkyT2OgZB{font-weight:700}._1yXkO4qdGolbNzBdpJgD6B{border-bottom:.07143rem solid #ccc;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around;list-style:none;padding:.71429rem 2.14286rem}._1yXkO4qdGolbNzBdpJgD6B li{-webkit-flex-basis:40%;-ms-flex-preferred-size:40%;flex-basis:40%}._1yXkO4qdGolbNzBdpJgD6B li:first-child{font-weight:700}._1yXkO4qdGolbNzBdpJgD6B li:first-child,._1yXkO4qdGolbNzBdpJgD6B li:last-child{-webkit-flex-basis:30%;-ms-flex-preferred-size:30%;flex-basis:30%}._334_9Fr9-ZeImegOjC_14o{width:50%}._1nyX7sv5_QVEk34wjArJy{width:65%}.GENPxmtPfAqp2rbxav429{min-height:2.5rem}._1K-56TjVIwnpkNyqNDNKTM{padding:0 2.14286rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudyPlan": "_3BD4fCxoBlGb_o_dYiDsnI",
	"StudyPlan_radio": "_1eK_pN6JRHDFwhQ5BUsBjK",
	"StudyPlan_radio_item": "AKbfVU8T4wHf_h3cSbtiI",
	"StudyPlan_table": "_3-hjxuS4QEEKDziXYpc0Kx",
	"StudyPlan_table_header": "_1_TS11IOA9_RwLkyT2OgZB",
	"StudyPlan_table_row": "_1yXkO4qdGolbNzBdpJgD6B",
	"StudyPlan_table_row_select": "_334_9Fr9-ZeImegOjC_14o",
	"StudyPlan_table_row_input": "_1nyX7sv5_QVEk34wjArJy",
	"StudyPlan_select_option": "GENPxmtPfAqp2rbxav429",
	"StudyPlan_buttons": "_1K-56TjVIwnpkNyqNDNKTM"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/IndividualDevelopmentPlan/IndividualDevelopmentPlanDetailView/StudyPlan/style.postcss
// module id = 1806
// module chunks = 0